import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetArticleStatusLogDetails } from "store/actions/articles";

export function useArticleReviewTracker(props) {
    const dispatch = useDispatch();
    const [data, setData] = useState(null)
    useEffect(() => {

        let id = props?.match?.params?.articleId
        if (id)
            fetchData(id);
    }, [])

    const fetchData = async (id: number) => {
        var res: any = await dispatch(
            GetArticleStatusLogDetails(id)
        );
        setData(res)

    };
    return { data }
}